import React from 'react';
import { FiCheckCircle, FiCircle, FiXCircle } from 'react-icons/fi';

const MatchStatusTimeline = ({ status = 'upcoming', date, startTime }) => {
  const statuses = [
    { key: 'upcoming', label: 'Recruiting', color: 'text-blue-500' },
    { key: 'started', label: 'Started', color: 'text-yellow-500' },
    { key: 'completed', label: 'Completed', color: 'text-green-500' },
    { key: 'cancelled', label: 'Cancelled', color: 'text-red-500' },
  ];

  const statusIndex = statuses.findIndex(s => s.key === status);

  return (
    <div className="bg-gray-800 p-6 rounded-lg border border-gray-700">
      <h3 className="text-white font-bold mb-4">Match Status</h3>
      
      {/* Status Timeline */}
      <div className="flex items-center justify-between">
        {statuses.map((s, index) => {
          const isActive = index === statusIndex;
          const isCompleted = (s.key === 'upcoming') || (s.key !== 'cancelled' && statusIndex > index);
          
          return (
            <div key={s.key} className="flex flex-col items-center flex-1">
              {/* Icon */}
              <div className={`mb-2 transition ${s.color}`}>
                {isActive ? (
                  <div className="w-10 h-10 rounded-full border-2 border-current flex items-center justify-center">
                    <FiCheckCircle size={20} />
                  </div>
                ) : status === 'cancelled' && s.key === 'cancelled' ? (
                  <FiXCircle size={24} />
                ) : isCompleted && status !== 'cancelled' ? (
                  <FiCheckCircle size={24} className="text-green-500" />
                ) : (
                  <FiCircle size={24} className="text-gray-600" />
                )}
              </div>
              
              {/* Label */}
              <p className={`text-xs font-semibold text-center ${
                isActive || isCompleted ? 'text-gray-300' : 'text-gray-500'
              }`}>
                {s.label}
              </p>
              
              {/* Connector Line */}
              {index < statuses.length - 1 && (
                <div className={`absolute h-1 w-12 ${
                  isCompleted && status !== 'cancelled' ? 'bg-green-500' : 'bg-gray-600'
                }`} style={{
                  top: '20px',
                  left: `${(index + 1) * 25}%`,
                  transform: 'translateX(-50%)',
                }}></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Status Badge */}
      <div className="mt-6 pt-6 border-t border-gray-700">
        <div className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full ${
            status === 'upcoming' ? 'bg-blue-500' :
            status === 'started' ? 'bg-yellow-500' :
            status === 'completed' ? 'bg-green-500' :
            'bg-red-500'
          }`}></div>
          <span className="text-gray-300 text-sm font-semibold capitalize">
            {status === 'upcoming' && 'Recruiting players'}
            {status === 'started' && 'Match in progress'}
            {status === 'completed' && 'Match completed'}
            {status === 'cancelled' && 'Match cancelled'}
          </span>
        </div>
        {date && (
          <p className="text-gray-400 text-xs mt-2">
            Scheduled: {new Date(date).toLocaleDateString()} {startTime ? `at ${startTime}` : ''}
          </p>
        )}
      </div>
    </div>
  );
};

export default MatchStatusTimeline;
